// 箭头对角线图标
const ArrowDiagonalIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="6"
      viewBox="0 0 6 6"
    >
      <path
        style={{ fill: "#29845A" }}
        fillRule="evenodd"
        d="M1 0.25a.75.75 0 0 0 0 1.5h2.19L.594 4.345a.75.75 0 1 0 1.06 1.06L4.25 2.811V5a.75.75 0 0 0 1.5 0V1a.748.748 0 0 0-.218-.529l-.002-.001-.001-.002A.748.748 0 0 0 5 0.25H1Z"
        clipRule="evenodd"
      />
    </svg>
  )
}

// 箭头向下图标
const ArrowDownIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="6"
      viewBox="0 0 6 6"
    >
      <path
        style={{ fill: "#616161" }}
        fillRule="evenodd"
        d="M5.75 1a.75.75 0 0 0-1.5 0v2.19L1.655.594a.75.75 0 1 0-1.06 1.06L3.189 4.25H1a.75.75 0 0 0 0 1.5h4a.748.748 0 0 0 .529-.218l.001-.002.002-.001A.748.748 0 0 0 5.75 5V1Z"
        clipRule="evenodd"
      ></path>
    </svg>
  )
}

export { ArrowDiagonalIcon, ArrowDownIcon }
